$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip({
        'delay': { show: 1000 }
    });
    var options = {
        trigger: "focus",
        container: 'body'
    };
    $('input[data-placement]').tooltip(options);
    options['placement'] = "right";
    $('input:not([data-placement])').tooltip(options);
});
